export const DEFAULT_COMPRESSION_MODE = 'speed';

export const SIZE_FIRST_MODE = 'small';

export const COMPRESSION_MODES = [
  {
    id: 'speed',
    name: '速度优先',
    quality: 85,
    webpEffort: 1,
    avifEffort: 1,
    pngLevel: 2,
    imageSmoothingQuality: 'medium'
  },
  {
    id: 'balanced',
    name: '均衡',
    quality: 78,
    webpEffort: 3,
    avifEffort: 3,
    pngLevel: 4,
    imageSmoothingQuality: 'high'
  },
  {
    id: 'quality',
    name: '质量优先',
    quality: 88,
    webpEffort: 5,
    avifEffort: 5,
    pngLevel: 6,
    imageSmoothingQuality: 'high'
  },
  {
    id: SIZE_FIRST_MODE,
    name: '体积优先',
    quality: 62,
    webpEffort: 4,
    avifEffort: 4,
    pngLevel: 5,
    imageSmoothingQuality: 'medium'
  }
];

/**
 * 按模式 id 获取压缩模式配置。
 * @param {string} mode 压缩模式 id。
 * @returns {object} 压缩模式配置。
 */
export function getCompressionMode(mode) {
  const matchedMode = COMPRESSION_MODES.find((item) => item.id === mode);

  // 未找到指定模式时回退到默认速度优先模式。
  if (!matchedMode) {
    return COMPRESSION_MODES.find(
      (item) => item.id === DEFAULT_COMPRESSION_MODE
    );
  }

  return matchedMode;
}
